(function () {
  function routesRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function formatCartTotal(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return (cents / 100).toFixed(2);
  }

  function updateHeaderCartTotal(cart) {
    document.querySelectorAll('.mevlana-header__cart-total').forEach(function (el) {
      el.textContent = formatCartTotal(cart.total_price);
    });
  }

  function initCartTotalSync() {
    if (typeof window.cartSubscribe !== 'function') return;

    var syncTimer = null;
    window.cartSubscribe(function (state) {
      if (state.changeLineLoading !== -1) return;

      clearTimeout(syncTimer);
      syncTimer = setTimeout(function () {
        fetch(routesRoot() + 'cart.js')
          .then(function (res) {
            return res.json();
          })
          .then(updateHeaderCartTotal)
          .catch(function () {});
      }, 80);
    });
  }

  function initMevlanaHeader() {
    var header = document.querySelector('.mevlana-header');
    if (!header) return;

    var panel = header.querySelector('[data-mevlana-shop-panel]');
    var navbar = header.querySelector('.mevlana-header__navbar');
    var triggers = header.querySelectorAll('[data-mevlana-shop-trigger]');

    if (panel && triggers.length) {
      function positionPanel() {
        if (!navbar) return;
        var rect = navbar.getBoundingClientRect();
        panel.style.setProperty('--mevlana-mega-top', rect.bottom + 'px');
      }

      function setOpen(open) {
        panel.classList.toggle('is-open', open);
        panel.setAttribute('aria-hidden', open ? 'false' : 'true');
        header.classList.toggle('mevlana-header--mega-open', open);
        triggers.forEach(function (trigger) {
          trigger.classList.toggle('is-open', open);
          var link = trigger.querySelector('.mevlana-nav__link');
          if (link) link.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
        if (open) positionPanel();
      }

      triggers.forEach(function (trigger) {
        trigger.addEventListener('mouseenter', function () {
          setOpen(true);
        });
        trigger.addEventListener('mouseleave', function (e) {
          if (!panel.contains(e.relatedTarget)) setOpen(false);
        });
        trigger.addEventListener('focusin', function () {
          setOpen(true);
        });
        trigger.addEventListener('focusout', function (e) {
          if (!panel.contains(e.relatedTarget)) setOpen(false);
        });
      });

      panel.addEventListener('mouseenter', function () {
        setOpen(true);
      });
      panel.addEventListener('mouseleave', function () {
        setOpen(false);
      });

      window.addEventListener(
        'scroll',
        function () {
          if (panel.classList.contains('is-open')) positionPanel();
        },
        { passive: true }
      );
      window.addEventListener('resize', positionPanel);
    }

    header.querySelectorAll('.mevlana-nav__item--children').forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        item.classList.add('is-open');
      });
      item.addEventListener('mouseleave', function () {
        item.classList.remove('is-open');
      });
      item.addEventListener('focusin', function () {
        item.classList.add('is-open');
      });
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) item.classList.remove('is-open');
      });
    });

    var mobileToggle = header.querySelector('[data-mevlana-mobile-toggle]');
    var mobileDrawer = header.querySelector('[data-mevlana-mobile-drawer]');
    var mobileBackdrop = header.querySelector('[data-mevlana-mobile-backdrop]');

    function positionMobileNav() {
      var main = header.querySelector('.mevlana-header__main');
      if (!main) return;
      var top = Math.round(main.getBoundingClientRect().bottom);
      header.style.setProperty('--mevlana-mobile-nav-top', top + 'px');
    }

    function setMobileOpen(open) {
      if (!mobileDrawer || !mobileToggle) return;
      if (open) {
        positionMobileNav();
        mobileDrawer.removeAttribute('hidden');
        if (mobileBackdrop) mobileBackdrop.removeAttribute('hidden');
      } else {
        mobileDrawer.setAttribute('hidden', '');
        if (mobileBackdrop) mobileBackdrop.setAttribute('hidden', '');
      }
      mobileToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      mobileToggle.setAttribute('aria-label', open ? 'Menü schließen' : 'Menü');
      header.classList.toggle('mevlana-header--mobile-open', open);
      document.body.classList.toggle('mevlana-mobile-nav-open', open);
    }

    if (mobileToggle && mobileDrawer) {
      mobileToggle.addEventListener('click', function () {
        setMobileOpen(mobileDrawer.hasAttribute('hidden'));
      });
      if (mobileBackdrop) {
        mobileBackdrop.addEventListener('click', function () {
          setMobileOpen(false);
        });
      }
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') setMobileOpen(false);
      });
      window.addEventListener('resize', function () {
        if (window.innerWidth > 1024) setMobileOpen(false);
        else if (!mobileDrawer.hasAttribute('hidden')) positionMobileNav();
      });
      window.addEventListener(
        'scroll',
        function () {
          if (!mobileDrawer.hasAttribute('hidden')) positionMobileNav();
        },
        { passive: true }
      );
    }

    header.querySelectorAll('.mevlana-mobile-nav__acc').forEach(function (button) {
      button.addEventListener('click', function () {
        var group = button.closest('.mevlana-mobile-nav__group');
        var panel = group && group.querySelector('.mevlana-mobile-nav__panel');
        if (!panel) return;
        var willOpen = panel.hasAttribute('hidden');
        panel.toggleAttribute('hidden', !willOpen);
        button.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
    });

    function updateScrollState() {
      header.classList.toggle('mevlana-header--scrolled', window.scrollY > 12);
    }

    updateScrollState();
    window.addEventListener('scroll', updateScrollState, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initMevlanaHeader();
      initCartTotalSync();
    });
  } else {
    initMevlanaHeader();
    initCartTotalSync();
  }
})();
